import { render, staticRenderFns } from "./qualifiedProductList.vue?vue&type=template&id=36c56226&scoped=true&"
import script from "./qualifiedProductList.vue?vue&type=script&lang=js&"
export * from "./qualifiedProductList.vue?vue&type=script&lang=js&"
import style0 from "./qualifiedProductList.vue?vue&type=style&index=0&id=36c56226&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c56226",
  null
  
)

export default component.exports